import React, { Component } from 'react'
import { withRouter } from 'react-router'
import { connect } from 'react-redux'
import { translate } from 'react-i18next'
import _ from 'lodash'

import { generateStatusTabs } from '../../helpers'
import { storeStatusTab } from '../../actions'
import ContactsList from './ContactsList'
import Loading from '../Loading'

import { Tabs, Badge, Input, Tag, Tooltip, Icon } from 'antd'
const TabPane = Tabs.TabPane
const Search = Input.Search

function accentFold (inputString) {
  return inputString.replace(
    /([àáâãäå])|([ç])|([èéêë])|([ìíîï])|([ñ])|([òóôõöø])|([ß])|([ùúûü])|([ÿ])|([æ])/g,
    function (str, a, c, e, i, n, o, s, u, y, ae) {
      if (a) return 'a'
      if (c) return 'c'
      if (e) return 'e'
      if (i) return 'i'
      if (n) return 'n'
      if (o) return 'o'
      if (s) return 's'
      if (u) return 'u'
      if (y) return 'y'
      if (ae) return 'ae'
    }
  )
}

function searchInString (string, search) {
  return accentFold(string.toLowerCase()).indexOf(search.toLowerCase()) !== -1
}

class ContactsTabs extends Component {
  state = {
    contacts: null,
    searchString: null
  }

  componentDidMount = () => {
    this.setState({
      contacts: this.props.contacts
    })
  }

  handleTabChange = key => {
    const { storeStatusTab } = this.props

    storeStatusTab(key)
  }

  handleSearch = value => {
    if (value) {
      // search in company name, contact first and last name
      const filteredContacts = _.pickBy(
        this.props.contacts,
        c =>
          (c.company && searchInString(c.company, value)) ||
          (c.firstName && searchInString(c.firstName, value)) ||
          (c.lastName && searchInString(c.lastName, value)) ||
          (c.comment && searchInString(c.comment, value))
      )

      this.setState({
        contacts: filteredContacts,
        searchString: value
      })
    }
  }

  clearSearch = () => {
    this.setState({
      contacts: this.props.contacts,
      searchString: null
    })

    this.searchInput.value = null
  }

  render () {
    // console.log(' RENDER: ContactsTabs')

    const {
      t,
      match: { params },
      projects,
      nav
    } = this.props

    if (!this.state.contacts) return <Loading />

    const groupedContacts = _.groupBy(this.state.contacts, c => c.status)
    const statusTabs = generateStatusTabs(projects[params.projectId].possibleCalls)

    return (
      <div>
        <div style={{ textAlign: 'center', marginBottom: 35 }}>
          <Search
            onSearch={value => this.handleSearch(value)}
            ref={input => (this.searchInput = input)}
            enterButton
            style={{ maxWidth: 350 }}
          />

          <Tooltip title='you can search in following fields: [company, firstName, lastName, comment]'>
            <Icon type='info-circle' style={{ marginLeft: 10 }} />
          </Tooltip>

          {this.state.searchString && (
            <div>
              search:
              <Tag closable onClose={() => this.clearSearch()} style={{ marginLeft: 5, marginTop: 5 }} color='blue'>
                {this.state.searchString}
              </Tag>
            </div>
          )}
        </div>

        <Tabs
          tabPosition='left'
          /* type='card' */ onChange={this.handleTabChange}
          defaultActiveKey={nav.statusTab || '0'}
        >
          {_.map(statusTabs, (statusName, statusNumber) => {
            const numberOfContactsInThisTab = groupedContacts[statusNumber] && groupedContacts[statusNumber].length

            return (
              <TabPane
                tab={
                  <span>
                    {t(`contact.status.${statusName}`)}{' '}
                    <Badge count={numberOfContactsInThisTab} overflowCount={999} style={{ backgroundColor: '#ccc' }} />
                  </span>
                }
                key={statusNumber}
              >
                <ContactsList data={groupedContacts[statusNumber]} key={this.state.searchString} />
              </TabPane>
            )
          })}
        </Tabs>
      </div>
    )
  }
}

// =====================================
//  REDUX CONNECT
// -------------------------------------

const mapStateToProps = state => ({
  projects: state.projects,
  contacts: state.contacts,
  nav: state.nav
})

const mapDispatchToProps = {
  storeStatusTab
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(translate('translations')(ContactsTabs)))



// WEBPACK FOOTER //
// ./src/components/Contacts/ContactsTabs.js